module.exports = __webpack_public_path__ + "static/img/gamelist12.af599775.png";